import InteractionIcon from "components-for/interactions/interaction-icon";
import { Cell, Column, Heading } from "@edgetier/client-components";
import { Fragment, FunctionComponent, memo } from "react";
import { IInteraction } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-message-column.types";
import { sanitize } from "dompurify";
import "./interactions-table-message-column.scss";

/**
 * Preview of a interaction's content.
 * @returns Table column.
 */
const InteractionsTableMessageColumn: FunctionComponent<IProps> = () => {
    return (
        <Column>
            <Heading>Message</Heading>
            <Cell<IInteraction> className="interactions-table-message-column">
                {({ contentCleaned, interactionType, searchMatch, preview }) => (
                    <div className="interactions-table-message-column__content">
                        <InteractionIcon interactionType={interactionType} />
                        <div className="interactions-table-message-column__content__text">
                            {Array.isArray(preview) && preview.length > 0 ? (
                                preview.map((message, index, { length }) => (
                                    <Fragment key={index}>
                                        <span
                                            className="interactions-table-message-column__content__message"
                                            dangerouslySetInnerHTML={{ __html: sanitize(message) }}
                                        />
                                        {index + 1 < length && <span> &hellip; </span>}
                                    </Fragment>
                                ))
                            ) : typeof searchMatch === "string" ? (
                                <div dangerouslySetInnerHTML={{ __html: sanitize(searchMatch) }} />
                            ) : (
                                String(contentCleaned)
                            )}
                        </div>
                    </div>
                )}
            </Cell>
        </Column>
    );
};

export default memo(InteractionsTableMessageColumn);
